import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CleaningServicesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cleaning_services"}/>
}
